export const SET_MONITORAMENTOS = 'SET_MONITORAMENTOS';
export const UPDATE_MONITORAMENTOS = 'UPDATE_MONITORAMENTOS';
export const EXCLUIR_MONITORAMENTOS = 'EXCLUIR_MONITORAMENTOS';
export const MOVER_MONITORAMENTOS = 'MOVER_MONITORAMENTOS';
export const PUSH_MONITORAMENTOS = 'PUSH_MONITORAMENTOS';
export const LOADING_ICONS = 'LOADING_ICONS';
export const SET_ICONS_PATH = 'SET_ICONS_PATH';

export const CRIAR_MONITORAMENTO = 'CRIAR_MONITORAMENTO';
export const EDITAR_MONITORAMENTO = 'EDITAR_MONITORAMENTO';
export const SET_MONITORAMENTO = 'SET_MONITORAMENTO';
export const UPDATE_MONITORAMENTO = 'UPDATE_MONITORAMENTO';
export const SET_PASTAS_MONITORAMENTO = 'SET_PASTAS_MONITORAMENTO';
export const SET_PLANOS = 'SET_PLANOS';
export const SET_COBERTURA = 'SET_COBERTURA';
export const UPDATE_FILTRO_HELPCENTER = 'UPDATE_FILTRO_HELPCENTER';

export const SET_APARICOES = 'SET_APARICOES';
export const SET_APARICOES_FAVORITAS = 'SET_APARICOES_FAVORITAS';
export const SET_APARICOES_MONITORAMENTO = 'SET_APARICOES_MONITORAMENTO';
export const PUSH_APARICOES_MONITORAMENTO = 'PUSH_APARICOES_MONITORAMENTO';
export const PUSH_APARICOES_FAVORITAS = 'PUSH_APARICOES_FAVORITAS';
export const PUSH_APARICOES = 'PUSH_APARICOES';
export const VISUALIZAR_APARICOES = 'VISUALIZAR_APARICOES';
export const MARCAR_REFERENCIAS_NAO_VISUALIZADAS = 'MARCAR_REFERENCIAS_NAO_VISUALIZADAS';
export const MARCAR_NAO_VISUALIZADA_APARICOES = 'MARCAR_NAO_VISUALIZADA_APARICOES';
export const SET_ITENS_SELECIONADO = 'SET_ITENS_SELECIONADO';
export const SET_ITEM_SELECIONADO = 'SET_ITEM_SELECIONADO';
export const SET_APARICAO = 'SET_APARICAO';
export const ADD_HIGHLIGHT_APARICAO = 'ADD_HIGHLIGHT_APARICAO';
export const EXCLUIR_APARICOES = 'EXCLUIR_APARICOES';
export const FAVORITAR_APARICOES = 'FAVORITAR_APARICOES';
export const DESFAVORITAR_APARICOES = 'DESFAVORITAR_APARICOES';
export const CRIAR_PASTA_MONITORAMENTO = 'CRIAR_PASTA_MONITORAMENTO';
export const EDITAR_PASTA_MONITORAMENTO = 'EDITAR_PASTA_MONITORAMENTO';
export const EXCLUIR_PASTA_MONITORAMENTO = 'EXCLUIR_PASTA_MONITORAMENTO';
export const ATUALIZAR_NOTIFICACOES_NAO_VISUALIZADAS = 'ATUALIZAR_NOTIFICACOES_NAO_VISUALIZADAS';
export const ATUALIZAR_PASTA_EM_NOTIFICACOES = 'ATUALIZAR_PASTA_EM_NOTIFICACOES';
export const REMOVER_MONITORAMENTO_PASTA = 'REMOVER_MONITORAMENTO_PASTA';
export const VISUALIZAR_NOTIFICACOES = 'VISUALIZAR_NOTIFICACOES';
export const VISUALIZAR_APARICOES_MONITORAMENTO = 'VISUALIZAR_APARICOES_MONITORAMENTO';
export const MUDAR_PAGINA_DIARIO = 'MUDAR_PAGINA_DIARIO';

export const SET_REFERENCIAS_PROCESSO = 'SET_REFERENCIAS_PROCESSO';
export const VISUALIZAR_REFERENCIAS_PROCESSO = 'VISUALIZAR_REFERENCIAS_PROCESSO';
export const EXCLUIR_REFERENCIAS_PROCESSO = 'EXCLUIR_REFERENCIAS_PROCESSO';
export const SET_QUANTIDADE_APARICOES_NAO_VISUALIZADAS = 'SET_QUANTIDADE_APARICOES_NAO_VISUALIZADAS';

export const RESETAR_APARICOES = 'RESETAR_APARICOES';
export const SET_ORIGENS = 'SET_ORIGENS';
export const SET_PROCESSO = 'SET_PROCESSO';
export const SET_MOVIMENTACOES = 'SET_MOVIMENTACOES';
export const APPEND_MOVIMENTACOES = 'APPEND_MOVIMENTACOES';
export const RESET_MOVIMENTACOES = 'RESET_MOVIMENTACOES';
export const CHECK_ALL_ORIGENS = 'CHECK_ALL_ORIGENS';
export const CHECK_DIARIO = 'CHECK_ORIGEM';
export const TOGGLE_DIARIO = 'TOGGLE_ORIGEM';
export const RESET_DIARIOS = 'RESET_DIARIOS';
export const TOGGLE_ORIGEM = 'CHECK_ORIGEM';
export const OPEN_ORIGEM = 'OPEN_ORIGEM';
export const SET_USUARIO = 'SET_USUARIO';
export const LER_NOTIFICACAO = 'LER_NOTIFICACAO';
export const LER_TODAS_NOTIFICACOES = 'LER_TODAS_NOTIFICACOES';
export const VISUALIZAR_TODAS_NOTIFICACOES = 'VISUALIZAR_TODAS_NOTIFICACOES';

export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
export const CLOSE_LOADING = 'CLOSE_LOADING';
export const SHOW_LOADING_MESSAGE = 'SHOW_LOADING_MESSAGE';
export const SET_LOADING_TIMEOUT = 'SET_LOADING_TIMEOUT';
export const RESET_LOADING_TIMEOUT = 'RESET_LOADING_TIMEOUT';

export const FECHAR_PASTA = 'FECHAR_PASTA';
export const ABRIR_PASTA = 'ABRIR_PASTA';
export const TOGGLE_PASTA = 'TOGGLE_PASTA';
export const TOGGLE_MENU = 'TOGGLE_MENU';

export const SET_FATURAS = 'SET_FATURAS';
export const SET_MESSAGES = 'SET_MESSAGES';
export const UNSET_MESSAGE = 'UNSET_MESSAGE';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';

export const SET_CIDADE_IP = 'SET_CIDADE_IP';
export const ATUALIZAR_STATUS_SUGESTAO = 'ATUALIZAR_STATUS_SUGESTAO';


export const ROUTER_PUSH = 'ROUTER_PUSH';
export const ROUTER_POP = 'ROUTER_POP';

export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM';
export const UPDATE_SEARCH_RESULTS = 'UPDATE_SEARCH_RESULTS';

export const UPDATE_DUVIDA_ATUAL = 'UPDATE_DUVIDA_ATUAL';
export const SOMAR_QUANTIDADE_DUVIDAS = 'SOMAR_QUANTIDADE_DUVIDAS';

export const ATUALIZAR_PROCESSO_AUTOS = 'ATUALIZAR_PROCESSO_AUTOS';
export const LIMPAR_PROCESSO_AUTOS = 'LIMPAR_PROCESSO_AUTOS';

export const SET_SUGESTOES_MONITORAMENTO = 'SET_SUGESTOES_MONITORAMENTO';
export const LOADMORE_SUGESTOES_MONITORAMENTO = 'LOADMORE_SUGESTOES_MONITORAMENTO';